export const DROPDOWN_DEFAULT_VALUE = 'all';

export const DROPDOWN_DEFAULT_VALUE_KITCHEN_GALLERY = {
  tab: 'ALL PRODUCT',
  value: 'ALL PRODUCT'
};

export const DROPDOWN_DEFAULT_VALUE_FOOD_TYPE = {
  tab: 'FOOD TYPE',
  value: 'FOOD TYPE'
};

export const DROPDOWN_DEFAULT_VALUE_PRODUCTS = {
  tab: 'PRODUCTS',
  value: 'PRODUCTS'
};
